<template>
<div>
  <video
    class="tutorial-video"
    ref="tutorialVideo"
    preload
    autoplay
    controls
    muted
    playsinline
    poster="@/assets/images/send-help-tutorial-first-frame.png"
  >
    <source src="@/assets/videos/SendHelpTutorialVideo.webm" type="video/webm">
    <source src="@/assets/videos/SendHelpTutorialVideo.mp4" type="video/mp4">
    Your browser doesn't support embedded videos.
  </video>
</div>
</template>

<script>
export default {
  name: 'SendHelpTutorial',
  data() {
    return {
    }
  },
  mounted() {
    const video = this.$refs.tutorialVideo;
    if (video) {
      // On iOS, the video does not auto play without user interaction or playsinline attr
      // due to their new <video> policies
      try {
        setTimeout(() => {
          video.play && video.play();
        }, 100);
      // eslint-disable-next-line
      } catch (err) {}

      if (video.requestFullscreen) {
        video.requestFullscreen();
      } else if (video.msRequestFullscreen) {
        video.msRequestFullscreen();
      } else if (video.mozRequestFullScreen) {
        video.mozRequestFullScreen();
      } else if (video.webkitRequestFullscreen) {
        video.webkitRequestFullscreen();
      }
    }

    // Set up full screen listener
    if (document.addEventListener) {
      document.addEventListener('fullscreenchange', this.onFullScreenChange, false);
      document.addEventListener('mozfullscreenchange', this.onFullScreenChange, false);
      document.addEventListener('MSFullscreenChange', this.onFullScreenChange, false);
      document.addEventListener('webkitfullscreenchange', this.onFullScreenChange, false);
    }
  },
  methods: {
    onFullScreenChange() {
      const notFullScreen = !document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement;
      const oWebViewInterface = window.nsWebViewInterface; // Use to emit event to native app

      oWebViewInterface && notFullScreen && oWebViewInterface.emit('exitFullScreen', true);
      window.ReactNativeWebView && notFullScreen && window.ReactNativeWebView.postMessage(
        JSON.stringify({ exitFullScreen: true })
      );
    }
  }
}
</script>

<style lang="scss">
.tutorial-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
